import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import PointValue from "./controls/PointValue";
import MeasureValue from "./controls/MeasureValue";
import BooleanValue from "./controls/BooleanValue";

export function PozoAguaSubterraneaList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((pozoAguaSubterranea, index) => (
        <ListGroupObjectItem
          key={pozoAguaSubterranea.orden}
          index={index}
          indexLabel={t("pozoAguaSubterranea.orden")}
          value={pozoAguaSubterranea}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("pozosAguaSubterranea").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <PointValue
                    label={t("pozoAguaSubterranea.ubicacion")}
                    value={value.ubicacion}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  {" "}
                  <MeasureValue
                    label={t("pozoAguaSubterranea.caudalMedio")}
                    value={value.caudalMedio}
                  />
                </Col>
                <Col lg={4}>
                  <MeasureValue
                    label={t("pozoAguaSubterranea.caudalPico")}
                    value={value.caudalPico}
                  />
                </Col>
                <Col lg={4}>
                  <MeasureValue
                    label={t("pozoAguaSubterranea.profundidad")}
                    value={value.profundidad}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BooleanValue
                    label={t("pozoAguaSubterranea.caudalimetroFunciona")}
                    value={pozoAguaSubterranea.caudalimetroFunciona}
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
